import { useMemo } from 'react';
import { getBillModeOptions, getDefaultBillMode, getDefaultIssueDate, normalizeEffectiveDate } from '~/components/BillModal/components/BillingDate/BillingDate.utils';
import { billClientModalTextsPath } from '~/components/BillModal/components/BillServiceTableItem/BillServiceTableItem.utils';
import { useLocaleKeys } from '~/i18n';
import { useIoContext } from '~/providers/IoContext';
export const useBillingModeData = (param)=>{
    let { invoiceDateInfo, effectiveDate = null, earliestBillableDate } = param;
    const { getNow } = useIoContext();
    const { t: billTexts } = useLocaleKeys(billClientModalTextsPath);
    const billModeOptions = useMemo(()=>getBillModeOptions({
            now: getNow(),
            effectiveDate,
            invoiceDateInfo,
            billModeTexts: billTexts.billModeOptions
        }), [
        effectiveDate,
        invoiceDateInfo
    ]);
    const defaultMode = useMemo(()=>getDefaultBillMode(billModeOptions, invoiceDateInfo), [
        billModeOptions,
        invoiceDateInfo
    ]);
    const defaultIssueDate = useMemo(()=>getDefaultIssueDate(defaultMode, invoiceDateInfo, getNow(), normalizeEffectiveDate(effectiveDate), earliestBillableDate), [
        defaultMode,
        invoiceDateInfo,
        effectiveDate,
        earliestBillableDate
    ]);
    return {
        billModeOptions,
        defaultMode,
        defaultIssueDate
    };
};
